export const translations = {
  en: {
    // Common / Shared
    common: {
      signIn: 'Sign In',
      signOut: 'Sign Out',
      signUp: 'Sign Up',
      account: 'Account',
      myAccount: 'My Account',
      myCertificates: 'My Certificates',
      followUs: 'Follow Us',
      language: 'Language',
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      close: 'Close',
      submit: 'Submit',
      back: 'Back',
      next: 'Next',
      previous: 'Previous',
      viewAll: 'View All',
      learnMore: 'Learn More',
      getStarted: 'Get Started',
      tryFree: 'Try Free',
      subscribe: 'Subscribe',
      free: 'Free',
      premium: 'Premium',
      professional: 'Professional',
      explorer: 'AI Access Starter',
      search: 'Search',
      filter: 'Filter',
      all: 'All',
      select: 'Select',
      instead: 'instead',
      noResults: 'No results found',
      tryAgain: 'Try Again',
      complete: 'Complete',
      perMonth: '/month',
      comingSoon: 'Coming Soon',
      availableNow: 'Available Now',
      required: 'Required',
      optional: 'Optional',
      yes: 'Yes',
      no: 'No',
      confirm: 'Confirm',
      continue: 'Continue',
      start: 'Start',
      finish: 'Finish',
      complete: 'Complete',
      incomplete: 'Incomplete',
      inProgress: 'In Progress',
      notStarted: 'Not Started',
      view: 'View',
      download: 'Download',
      share: 'Share',
      copy: 'Copy',
      clear: 'Clear',
      reset: 'Reset',
      refresh: 'Refresh',
      tryAgain: 'Try Again',
      retake: 'Retake',
      review: 'Review',
      bookmark: 'Bookmark',
      bookmarked: 'Bookmarked',
      removeBookmark: 'Remove Bookmark',
      progress: 'Progress',
      score: 'Score',
      correct: 'Correct',
      incorrect: 'Incorrect',
      total: 'Total',
      of: 'of',
      minute: 'minute',
      minutes: 'minutes',
      hour: 'hour',
      hours: 'hours',
      day: 'day',
      days: 'days',
      month: 'month',
      perMonth: '/month',
      year: 'year',
      perYear: '/year',
      quiz: 'Quiz',
      flashcards: 'Flashcards',
      learn: 'Learn',
      practice: 'Practice',
      exam: 'Exam',
      test: 'Test',
      question: 'Question',
      answer: 'Answer',
      hint: 'Hint',
      explanation: 'Explanation',
      showAnswer: 'Show Answer',
      hideAnswer: 'Hide Answer',
      flipCard: 'Flip Card',
      nextCard: 'Next Card',
      previousCard: 'Previous Card',
      startQuiz: 'Start Quiz',
      submitQuiz: 'Submit Quiz',
      quizComplete: 'Quiz Complete!',
      yourScore: 'Your Score',
      passed: 'Passed',
      failed: 'Failed',
      educationalOnly: 'Educational Only',
      disclaimer: 'Disclaimer',
    },
    // Navigation
    nav: {
      home: 'Home',
      topics: 'Topics',
      academy: 'Sleep Reset Academy',
      videos: 'Videos',
      about: 'About',
      organizations: 'For Organizations',
      membership: 'Membership',
      techPocketGuide: 'Tech Pocket Guide',
      scoringMastery: 'Scoring Mastery',
      examPrep: 'Exam Prep',
      questionBanks: 'Question Banks',
      admin: 'Admin',
      adminPanel: 'Admin Panel',
      adminLogin: 'Admin Login',
      testimonials: 'Success Stories',
      aboutDoctor: 'About Dr. Edgar',
      contact: 'Contact / Work with Me',
      dashboard: 'Dashboard',
      certificates: 'Certificates',
      research: 'Research',
      profile: 'Profile',
      settings: 'Settings',
      help: 'Help',
      logout: 'Logout',
      sleepCoach: 'Sleep Coach',
      cpapAdherence: 'CPAP Journey',
      sleepAssessment: 'Sleep Assessment',
      wearableInsights: 'Wearable Insights',
    },
    // Homepage
    home: {
      heroTitle: 'Advancing Sleep Medicine Education and Clinical Training',
      heroSubtitle: 'Interactive learning, certification preparation, and scoring quality assurance tools designed for sleep technologists, clinicians, and healthcare organizations.',
      explorePathsBtn: 'Explore Learning Paths',
      tryScoringBtn: 'Try Scoring Mastery',
      whatWeOfferTitle: 'A Complete Platform for Sleep Medicine Learning',
      whatWeOfferDesc: 'From foundational sleep education to advanced clinical scoring training, Sleep Health Services provides tools for students, technologists, and healthcare teams to develop expertise in sleep medicine.',
      educationCard: 'Education',
      educationDesc: 'Interactive resources covering sleep disorders, neuroscience, and sleep health.',
      certPrepCard: 'Certification Prep',
      certPrepDesc: 'Practice exams, case studies, and learning modules designed for sleep technologist certification.',
      clinicalCard: 'Clinical Training',
      clinicalDesc: 'Hands-on scoring exercises with rule-based feedback aligned with AASM guidelines.',
      qaCard: 'Quality Assurance',
      qaDesc: 'Scoring Mastery helps laboratories standardize training and improve scoring accuracy.',
      forWhoTitle: 'Designed for Every Stage of Sleep Medicine Learning',
      studentsCard: 'Students',
      studentsDesc: 'Build a strong foundation in sleep science and sleep disorders.',
      techsCard: 'Sleep Technologists',
      techsDesc: 'Practice scoring, improve accuracy, and prepare for certification exams.',
      healthcareCard: 'Healthcare Professionals',
      healthcareDesc: 'Expand clinical knowledge and stay updated with modern sleep medicine.',
      labsCard: 'Sleep Laboratories',
      labsDesc: 'Train teams and maintain scoring consistency using Scoring Mastery.',
      techGuideTitle: 'The Interactive Reference for Sleep Technologists',
      techGuideDesc: 'Access practical guidance on patient hookup, scoring rules, artifacts, EKG rhythms, medications, and clinical procedures.',
      openTechGuide: 'Open Tech Pocket Guide',
      scoringTitle: 'Train, Evaluate, and Improve Scoring Accuracy',
      scoringDesc: 'Scoring Mastery provides interactive scoring exercises with structured feedback based on established scoring rules. Laboratories can use it as a training and quality assurance tool.',
      exploreScoringBtn: 'Explore Scoring Mastery',
      choosePathTitle: 'Choose Your Learning Path',
      choosePathDesc: 'From foundational education to professional certification preparation, find the right membership for your learning goals.',
      learnPracticeImprove: 'Learn. Practice. Improve.',
      learnPracticeDesc: 'Sleep Health Services combines education, interactive training, and clinical practice tools to support the next generation of sleep medicine professionals.',
      viewOptionsBtn: 'View Learning Options',
      createAccountBtn: 'Create Free Account',
    },
    // Topics
    topics: {
      title: 'Sleep Medicine Topics',
      subtitle: 'Explore comprehensive educational content on sleep health and disorders',
      browse: 'Browse Sleep Medicine Topics',
      searchPlaceholder: 'Search topics, symptoms, treatments...',
      allTopics: 'All Topics',
      noResults: 'No topics found matching your search.',
      video: 'Video',
      readMore: 'Read More',
      relatedTopics: 'Related Topics',
      categories: 'Categories',
      filterByCategory: 'Filter by Category',
      sortBy: 'Sort by',
      newest: 'Newest',
      popular: 'Popular',
      alphabetical: 'Alphabetical',
    },
    // Topic Detail
    topicDetail: {
      backToTopics: 'Back to Topics',
      published: 'Published:',
      about: 'About',
      importantInfo: 'Important Information',
      disclaimer: 'This educational content is provided for informational purposes only. Always consult with a qualified healthcare professional for diagnosis and treatment of sleep disorders.',
      relatedTopics: 'Related Topics',
      learnMore: 'Want to Learn More About',
      membershipDescription: 'Join our membership community to access comprehensive, in-depth educational materials covering all aspects of sleep medicine.',
      perMonth: 'per month',
      perYear: 'per year',
      monthlyMembership: 'Monthly membership',
      bestValue: 'BEST VALUE',
      joinMembership: 'Join Membership',
      whatYouGet: "What you'll get:",
      benefit1: 'Complete sleep medicine topic guides',
      benefit2: 'Exclusive educational videos',
      benefit3: 'Expert guidance and support',
      benefit4: 'Sleep technologist training resources',
      benefit5: 'CPSGT Exam Prep Review',
      benefit6: 'RPSGT Exam Prep Review',
      // Audio & Learning
      unlockAudioMode: 'Unlock Audio Mode',
      listenInEnglish: 'Listen in English',
      listenInSpanish: 'Escuchar en Español',
      keyTakeaways: 'Key Takeaways',
      unlockFullInteractive: 'Unlock Full Interactive Learning',
      unlockDescription: 'Get access to comprehensive content, audio narration, and interactive knowledge checks with an Explorer membership or higher.',
      unlockWithMembership: 'Unlock with Membership',
      knowledgeCheck: 'Knowledge Check',
      askAI: 'Ask SHS-AI',
      askAISubtitle: 'Get answers to your questions about this topic',
    },
    // Hero (legacy)
    hero: {
      title: 'Sleep Medicine Education',
      subtitle: 'Sleep Health Educator and Sleep Professional & Public Health and Preventive Medicine Specialist (Ph.D., not a medical doctor MD/DO)',
      description: 'I help patients, professionals, and sleep technologists understand sleep in a clear, practical way.',
      exploreTopics: 'Explore Topics',
      adminAccess: 'Admin Access',
      learnAcademy: 'Learn about Sleep Reset Academy',
      viewTraining: 'View CPSGT & RPSGT Training',
    },
    // Stats
    stats: {
      educationalTopics: 'Educational Topics',
      videoResources: 'Video Resources',
      categories: 'Categories',
      students: 'Students',
      courses: 'Courses',
      certificates: 'Certificates Issued',
    },
    // About
    about: {
      title: 'Expert Sleep Medicine Education',
      description: 'Welcome to Sleep Health Services Education Center. Our mission is to provide comprehensive, evidence-based information about sleep health and sleep disorders.',
      paragraph1: 'Welcome to Sleep Health Services Education Center.',
      paragraph2: 'We are committed to delivering high-quality educational content.',
      browseResources: 'Browse Educational Resources',
    },
    // Membership
    membership: {
      title: 'Join Sleep Health Services',
      subtitle: 'Master the science. Build the foundation.',
      description: 'Choose the membership tier that matches your sleep education goals.',
      educationalValueLayer: 'Educational Value Layer',
      choosePlan: 'Choose Your Access Level',
      currentPlan: 'Current Plan',
      upgrade: 'Upgrade',
      downgrade: 'Downgrade',
      cancel: 'Cancel Subscription',
      benefits: 'Benefits',
      pricing: 'Pricing',
      perMonth: '/month',
      perYear: '/year',
      annually: 'annually',
      monthly: 'monthly',
      bestValue: 'Best Value',
      mostPopular: 'Most Popular',
      examPrep: 'Exam Prep',
      popular: 'Popular',
      member: 'Member',
      youreA: "You're a",
      enjoyAccess: 'Enjoy your full access to all',
      featuresLabel: 'features',
      notIncluded: 'Not included',
      includedInYourPlan: 'Included in Your Plan',
      standaloneProduct: 'Standalone Product',
      improveYourSleep: 'Improve your sleep for just',
      goToSleepPlan: 'Go to Your Sleep Plan',
      startCoaching: 'Start Sleep Coaching',
      lookingForTraining: 'Looking for Technician Training?',
      exploreAcademy: 'Explore Sleep Reset Academy',
      productEcosystem: 'Our Product Ecosystem',
      strategicProducts: 'Strategic products for every stage of your sleep medicine journey.',
      freeTier: {
        name: 'Free',
        description: 'Start your sleep education journey',
        features: ['Browse website content', 'Preview topic summaries'],
      },
      explorerTier: {
        name: 'Explorer',
        description: 'Full access to 200+ sleep topics',
        tagline: 'Full access to 200+ sleep topics',
        features: [
          'Full access to ALL 200+ sleep topics',
          'Bilingual content (English & Spanish)',
          'Audio playback (limited preview)',
          'SHS-AI assistant (limited access)',
          'Sleep Coach access (preview)',
        ],
      },
      deepSleepTier: {
        name: 'Full Learning Access',
        description: 'Unlimited topics + audio + Sleep Coach + Wearables',
        tagline: 'Unlimited topics + audio + Sleep Coach + Wearables',
        features: [
          'Everything in Explorer',
          'Full access to premium topics',
          'Audio learning experience (unlimited)',
          'Sleep Coach access (full)',
          'Wearable Devices integration',
          'SHS-AI (limited access)',
          'Expanded interactive content',
        ],
      },
      masterMindTier: {
        name: 'AI Learning Pro',
        description: 'Unlimited SHS-AI + Sleep Coach + Wearables',
        tagline: 'Unlimited SHS-AI + Sleep Coach + Wearables',
        features: [
          'Everything in Full Learning Access',
          'Unlimited SHS-AI access',
          'Sleep Coach access (full)',
          'Wearable Devices integration',
          'Advanced learning content',
          'Priority AI support',
        ],
      },
      professionalTier: {
        name: 'Exam Prep Pro',
        description: 'Advanced training + scoring mastery',
        tagline: 'Advanced training + scoring mastery',
        features: [
          'Full platform access',
          'Question banks + advanced training',
          'Unlimited SHS-AI usage',
          'Exam-prep materials & mock tests',
        ],
        exclusions: [
          'Sleep Reset Academy modules (purchased separately)',
          'Team management features',
        ],
      },
      guarantee: 'All plans include a 7-day money-back guarantee. Cancel anytime.',
      compareFeatures: 'Compare Features',
      allFeatures: 'All Features',
      feature: 'Feature',
      mo: 'mo',
      preview: 'Preview',
      full: 'Full',
      unlimited: 'Unlimited',
      features: {
        knowledgeHub: 'Sleep Knowledge Hub Articles',
        premiumTopics: 'Premium Topics',
        audioLearning: 'Audio Learning',
        aiAssistant: 'SHS-AI Assistant',
        examPrep: 'Exam Preparation Materials',
        mockTests: 'Mock Tests & Quizzes',
      },
      academyNote: 'is a separate product designed for future sleep technologists entering the field. Academy modules are purchased individually, not included in any membership tier.',
    },
    // Academy
    academy: {
      title: 'Sleep Reset Academy',
      subtitle: 'Master the science. Build the foundation.',
      description: 'Professional sleep medicine education with certification preparation, expert-led courses, and progress tracking.',
      heading: 'Sleep Reset Academy — CPSGT to RPSGT Master Certification',
      intro: 'Sleep Reset Academy is the educational division of Sleep Health Services (SHS), created to train the next generation of sleep technologists.',
      viewOverview: 'View Academy Overview',
      allCourses: 'All Courses',
      myCourses: 'My Courses',
      inProgress: 'In Progress',
      completed: 'Completed',
      startCourse: 'Start Course',
      continueCourse: 'Continue',
      viewCourse: 'View Course',
      lessons: 'Lessons',
      modules: 'Modules',
      duration: 'Duration',
      level: 'Level',
      beginner: 'Beginner',
      intermediate: 'Intermediate',
      advanced: 'Advanced',
      certificate: 'Certificate',
      earnCertificate: 'Earn Certificate',
      downloadCertificate: 'Download Certificate',
      progress: 'Progress',
      completeLesson: 'Complete Lesson',
      nextLesson: 'Next Lesson',
      previousLesson: 'Previous Lesson',
      courseCompleted: 'Course Completed!',
      congratulations: 'Congratulations on completing this course!',
      professionalCertification: 'Exam Prep Pro',
      publicEducation: 'Public Education',
      generalEducation: 'General Education',
      knowledgeCheck: 'Knowledge Check',
      checkYourUnderstanding: 'Check Your Understanding',
      question: 'Question',
      submitAnswers: 'Submit Answers',
      tryAgain: 'Try Again',
      correct: 'Correct!',
      incorrect: 'Incorrect',
      explanation: 'Explanation',
      score: 'Score',
      passed: 'Passed',
      failed: 'Try Again',
      cpsgtTitle: 'CPSGT Sleep Technician Foundations',
      cpsgtBody: 'A complete introduction for new technologists: sleep basics, polysomnography fundamentals, sensor placement, staging, respiratory events, PAP basics, safety and documentation.',
      cpsgtLine: 'Available in English and Spanish.',
      cpsgtButton: 'View CPSGT Course',
      rpsgtTitle: 'RPSGT Advanced Scoring & Titration Mastery',
      rpsgtBody: 'Advanced training in AASM scoring, complex PAP titration, pediatric sleep, parasomnias, movement disorders, artifacts, and special populations.',
      rpsgtLine: 'Available in English and Spanish.',
      rpsgtButton: 'View RPSGT Course',
      bundleTitle: 'Master Sleep Technician Bundle',
      bundleBody: 'A complete pathway that combines CPSGT Foundations and RPSGT Mastery.',
      bundleLine: 'Includes bilingual workbooks and practice exams.',
      bundleButton: 'Explore the Bundle',
      howHeading: 'How the Academy Works',
      howBody: 'Study with bilingual video lessons, PowerPoint presentations, downloadable workbooks, and practice exams.',
      careerTrack: 'Career Track Product',
      whoIsThisFor: 'Who is this for?',
      alreadyWorking: 'Already a working technologist? Check out',
      examPrepPro: 'Exam Prep Pro',
      coursesStarted: 'Courses Started',
      manageAcademy: 'Manage Academy',
      modulesNotice: 'Academy modules are purchased individually — not included in any membership tier.',
      errorLoading: 'Error Loading Courses',
      noCoursesAvailable: 'No Courses Available',
      coursesPreparing: 'Courses are being prepared. Check back soon!',
    },
    // Videos
    videos: {
      title: 'Video Library',
      subtitle: 'Expert sleep education at your fingertips',
      description: 'Explore our comprehensive collection of educational videos on sleep medicine.',
      searchPlaceholder: 'Search videos...',
      allVideos: 'All Videos',
      featured: 'Featured',
      recent: 'Recent',
      popular: 'Popular',
      watchNow: 'Watch Now',
      duration: 'Duration',
      views: 'Views',
      category: 'Category',
      series: 'Series',
      episode: 'Episode',
      filterByTier: 'Filter by Access Level',
      filterBySeries: 'Filter by Series',
      freePreview: 'Free Preview',
      premiumContent: 'Premium Content',
      unlockWith: 'Unlock with',
      upgradeToWatch: 'Upgrade to Watch',
      startHere: 'Start Here',
      continueWatching: 'Continue Watching',
      recommended: 'Recommended for You',
      relatedVideos: 'Related Videos',
      noVideosFound: 'No videos found matching your criteria.',
      tierRequired: 'This content requires {tier} membership or higher.',
    },
    // Dashboard
    dashboard: {
      title: 'My Dashboard',
      welcome: 'Welcome back',
      overview: 'Overview',
      recentActivity: 'Recent Activity',
      courseProgress: 'Course Progress',
      achievements: 'Achievements',
      certificates: 'My Certificates',
      noCertificates: 'No certificates earned yet. Complete a course to earn your first certificate!',
      downloadAll: 'Download All',
      continueLeaving: 'Continue Where You Left Off',
      recommendedCourses: 'Recommended Courses',
      memberSince: 'Member since',
      currentTier: 'Current Tier',
      upgradeAccount: 'Upgrade Account',
      totalProgress: 'Total Progress',
      exercisesCompleted: 'Exercises Completed',
      quizzesCompleted: 'Quizzes Completed',
      bookmarks: 'Bookmarks',
      noActivity: 'No recent activity',
    },
    // Auth
    auth: {
      login: 'Login',
      register: 'Create Account',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      firstName: 'First Name',
      lastName: 'Last Name',
      forgotPassword: 'Forgot Password?',
      resetPassword: 'Reset Password',
      rememberMe: 'Remember me',
      noAccount: "Don't have an account?",
      hasAccount: 'Already have an account?',
      createOne: 'Create one',
      signInHere: 'Sign in here',
      orContinueWith: 'Or continue with',
      termsAgreement: 'By creating an account, you agree to our Terms of Service and Privacy Policy.',
      invalidCredentials: 'Invalid email or password',
      loginFailed: 'We could not sign you in. Please check your details and try again.',
      accountCreated: 'Account created successfully!',
      welcomeBack: 'Welcome back!',
      loggedInAs: 'Logged in as',
      accessDashboard: 'Access your sleep education dashboard',
      backToWebsite: 'Back to website',
      // Sprint 38 · P1 Fix — /education/register localization (Deep QA iter 153).
      createYourAccount: 'Create your account',
      startJourney: 'Start your sleep education journey today',
      preferredLanguage: 'Preferred Language',
      selectLanguage: 'Select language',
      passwordMinChars: 'Minimum 6 characters',
      creatingAccount: 'Creating account...',
      creatingAccountEllipsis: 'Creating your account...',
      accountCreatedRedirecting: 'Account created successfully! Redirecting...',
      welcomeToSHS: 'Account created! Welcome to Sleep Health Services!',
      registrationFailed: 'Registration failed',
      fillRequiredFields: 'Please fill in all required fields',
      passwordsDoNotMatch: 'Passwords do not match',
      passwordTooShort: 'Password must be at least 8 characters',
      signIn: 'Sign in',
      // Sprint 38 · Track A — Password Reset origination.
      forgotPasswordTitle: 'Reset your password',
      forgotPasswordSubtitle: 'Enter the email associated with your account and we\'ll send you a reset link.',
      forgotPasswordSubmit: 'Send reset link',
      forgotPasswordSending: 'Sending...',
      forgotPasswordNeutral: 'If an account exists for that email, reset instructions will be sent.',
      forgotPasswordCheckInbox: 'Check your inbox. If the email doesn\'t arrive within a few minutes, check spam or try again.',
      forgotPasswordBackToLogin: 'Back to sign in',
      // Sprint 38 · Track C — Session expired notice.
      sessionExpired: 'Your session expired. Please sign in again.',
      // Password reset completion (existing flow, previously hardcoded strings)
      resetSetPasswordTitle: 'Set your password',
      resetPasswordMinChars: 'Minimum 8 characters',
      resetPasswordNewLabel: 'New password',
      resetPasswordConfirmLabel: 'Confirm password',
      resetPasswordSubmit: 'Set password',
      resetPasswordSubmitting: 'Resetting...',
      resetPasswordSuccess: 'Password reset successful!',
      resetPasswordSuccessTitle: 'Password reset successful',
      resetPasswordSuccessBody: 'Your password has been updated. You can now sign in with your new password.',
      resetPasswordGoToLogin: 'Go to sign in',
      resetPasswordInvalidTitle: 'Invalid reset link',
      resetPasswordInvalidBody: 'This password reset link is invalid or has expired.',
      resetPasswordInvalidReturnBtn: 'Return to sign in',
      resetPasswordVerifying: 'Verifying reset token...',
      resetPasswordNoToken: 'No reset token provided',
      resetPasswordVerifyFailed: 'Failed to verify token. Please try again.',
      resetPasswordFailed: 'Failed to reset password. Please try again.',
      resetPasswordPasswordShort: 'Password must be at least 8 characters',
      resetPasswordSettingFor: 'Setting password for',
      resetPasswordEncrypted: 'Your password is securely encrypted',
    },
    // Technologist
    technologist: {
      title: 'Interested in Becoming a Sleep Technologist?',
      description: 'Join our membership community to access exclusive training materials.',
      examPrepTitle: 'Exam Prep Review Included',
      examPrepDescription: 'Prepare for your certification with our comprehensive review courses:',
      cpsgt: 'CPSGT Exam Prep',
      rpsgt: 'RPSGT Exam Prep',
      joinMembership: 'Join Our Membership Community',
      learnMore: 'Learn More',
      pricing: 'or',
      perMonth: '/month',
      perYear: '/year',
      benefits: 'Access training courses, CPSGT & RPSGT exam prep, and ongoing support',
    },
    // CTA
    cta: {
      title: 'Need Professional Sleep Health Services?',
      description: 'Sleep Health Services offers comprehensive sleep medicine solutions.',
      contactUs: 'Contact Us',
      readyToTransform: 'Ready to Transform Your Sleep Education?',
      joinThousands: 'Join thousands of learners advancing their sleep medicine knowledge.',
      viewMembership: 'View Membership Plans',
      createFreeAccount: 'Create Free Account',
    },
    // Footer
    footer: {
      tagline: 'Education, Training, and Quality Improvement in Sleep Medicine',
      description: 'Comprehensive education, certification preparation, and clinical training tools for sleep technologists, clinicians, and healthcare organizations.',
      quickLinks: 'Quick Links',
      browseTopics: 'Browse Topics',
      becomeTechnologist: 'Become a Sleep Technologist',
      adminPortal: 'Admin Portal',
      contact: 'Contact',
      location: 'Humacao, Puerto Rico',
      availableSoon: 'Available Soon',
      copyright: 'Sleep Health Services. All rights reserved.',
      disclaimer: 'Educational content for informational purposes only. Consult healthcare professionals for medical advice.',
      followUs: 'Follow Us',
      privacyPolicy: 'Privacy Policy',
      termsOfService: 'Terms of Service',
    },
    // Tech Pocket Guide
    techPocketGuide: {
      title: 'Tech Pocket Guide',
      subtitle: 'The Interactive Reference for Sleep Technologists',
      description: 'Access practical guidance on patient hookup, scoring rules, artifacts, EKG rhythms, medications, and clinical procedures.',
      enterGuide: 'Enter Pocket Guide',
      disclaimer: 'This content is for educational reference — not diagnosis. Always follow facility protocols.',
      interactiveReference: 'Interactive Reference',
      modules: {
        ekg: 'EKG Rhythms',
        hookup: 'Patient Hookup',
        artifacts: 'Artifacts',
        scoring: 'Scoring Rules',
        procedures: 'Procedures',
        medications: 'Medications',
        glossary: 'Glossary',
      },
      // Module descriptions for landing page
      moduleDescriptions: {
        hookup: '10-20 EEG system, electrode placement, measurement guides',
        artifacts: 'Signal pathways, common artifacts, correction logic',
        scoring: 'Sleep staging, respiratory events, arousals, PLMs, formulas',
        ekg: 'Educational rhythm recognition, rate/rhythm/P-QRS-T analysis',
        procedures: 'Order of operations, calibrations, MSLT/MWT, templates',
        medications: 'Sleep medications, mechanisms, contraindications',
        glossary: 'Searchable glossary with rule-linked definitions',
      },
      moduleInteractive: {
        hookup: ['Placement quizzes', 'Visual checkpoints'],
        artifacts: ['"What artifact is this?" cards', 'Fix-the-signal scenarios'],
        scoring: ['Scoring decision trees', 'Rule-anchored explanations'],
        ekg: ['Rhythm recognition cards', '"Is this concerning?" prompts'],
        procedures: ['Checklists', 'Sample protocols'],
        medications: ['Educational reference cards'],
        glossary: ['Search', 'Cross-module links'],
      },
      highPriority: 'HIGH PRIORITY',
      // Value propositions
      valueProps: {
        builtForLab: 'Built for the Lab',
        builtForLabPoints: [
          'Practical, step-by-step guidance',
          'Real-world troubleshooting',
          'Clear explanations technologists actually understand'
        ],
        interactive: 'Interactive, Not Static',
        interactivePoints: [
          'Quizzes, flashcards, and scenarios',
          'Rhythm recognition practice',
          'Scoring decision walkthroughs'
        ],
        safeEducational: 'Safe & Educational',
        safeEducationalPoints: [
          'Rule-anchored explanations',
          'Non-diagnostic language',
          'Designed for education, not prescribing'
        ],
      },
      // Audiences
      audiences: [
        'Sleep Technologists (students & working techs)',
        'Lab supervisors & QA teams',
        'Educators & training programs',
        'Physicians who want standardized references',
        'General public seeking accurate sleep education'
      ],
      whoIsThisFor: 'Who Is This For?',
      learnMode: 'Learn',
      flashcardsMode: 'Flashcards',
      quizMode: 'Quiz',
      allCategories: 'All Categories',
      cardOf: 'Card {current} of {total}',
      clickToFlip: 'Click to flip',
      characteristics: 'Characteristics',
      causes: 'Causes',
      troubleshooting: 'Troubleshooting',
      prevention: 'Prevention',
      clinical: 'Clinical',
      criteria: 'Criteria',
      tip: 'Tip',
      urgent: 'Urgent',
      document: 'Document',
    },
    // Scoring Mastery
    scoringMastery: {
      title: 'Scoring Mastery™',
      heroTitle: 'Standardize Sleep Study Scoring with Confidence',
      heroSubtitle: 'Scoring Mastery™ is an interactive training and quality assurance platform designed to improve scoring accuracy, reduce variability, and support laboratory performance.',
      requestPilot: 'Request Pilot Access',
      viewDemo: 'View Demo',
      problemTitle: 'Inconsistent Scoring Is a Hidden Risk',
      problemDesc: 'Sleep laboratories often face variability in scoring between technologists, leading to inconsistencies, retraining needs, and potential audit challenges.',
      problemPoint1: 'Variability between scorers',
      problemPoint2: 'Limited structured training tools',
      problemPoint3: 'Time-consuming manual QA review',
      problemPoint4: 'Difficulty maintaining consistency across teams',
      solutionTitle: 'A Smarter Approach to Training and Quality Assurance',
      solutionDesc: 'Scoring Mastery™ combines interactive training with rule-based feedback to help technologists improve accuracy and maintain consistent scoring practices.',
      capability1: 'Interactive scoring exercises',
      capability2: 'Rule-based feedback aligned with current guidelines',
      capability3: 'Performance tracking across domains',
      capability4: 'Structured training for new and experienced technologists',
      howItWorksTitle: 'How Scoring Mastery Works',
      step1Title: 'Practice',
      step1Desc: 'Technologists complete structured scoring exercises using simulated PSG data.',
      step2Title: 'Compare',
      step2Desc: 'The platform compares user scoring with a reference standard.',
      step3Title: 'Learn',
      step3Desc: 'Detailed feedback explains the reasoning behind each scoring decision.',
      step4Title: 'Improve',
      step4Desc: 'Users track progress and improve performance over time.',
      featuresTitle: 'Built for Real-World Sleep Lab Training',
      respiratory: 'Respiratory Scoring',
      respiratoryDesc: 'Practice apnea, hypopnea, and RERA identification.',
      desaturation: 'Oxygen Desaturation',
      desaturationDesc: 'Learn baseline identification and desaturation scoring.',
      plm: 'Periodic Limb Movements',
      plmDesc: 'Identify movement sequences and calculate PLM index.',
      cardiac: 'Cardiac Rhythm Recognition',
      cardiacDesc: 'Recognize common rhythms and understand escalation protocols.',
      pediatric: 'Pediatric Mode',
      pediatricDesc: 'Adjust criteria and training for pediatric sleep studies.',
      dashboard: 'Quality Dashboard',
      dashboardDesc: 'Track performance, identify training needs, and monitor improvement.',
      valueTitle: 'Designed for Sleep Laboratories',
      valueDesc: 'Scoring Mastery™ supports both individual learning and team-wide quality improvement.',
      benefit1: 'Improve scoring consistency',
      benefit2: 'Support technologist training',
      benefit3: 'Reduce QA workload',
      benefit4: 'Prepare for accreditation and audits',
      ctaTitle: 'Start with a Pilot Program',
      ctaDesc: 'We offer pilot access for sleep laboratories interested in evaluating Scoring Mastery™ with their team.',
      contactUs: 'Contact Us',
      footerNote: 'Scoring Mastery™ is intended for educational and training purposes only and does not replace clinical judgment or facility protocols.',
      // Form fields
      organizationName: 'Organization Name',
      organizationType: 'Organization Type',
      technicianCount: 'Number of Technologists',
      contactName: 'Contact Name',
      contactEmail: 'Contact Email',
      additionalInfo: 'Additional Information',
      hospitalLab: 'Hospital Sleep Lab',
      idtf: 'IDTF / Independent Lab',
      healthSystem: 'Health System (Multi-Site)',
      academic: 'Academic Medical Center',
      vaCenter: 'VA Medical Center',
      requestReceived: 'Request Received',
      thankYou: 'Thank you for your interest in Scoring Mastery™. Our team will review your submission and contact you shortly.',
      // Exercise page
      exercises: 'Exercises',
      domains: 'Domains',
      selectDomain: 'Select a Domain',
      startExercise: 'Start Exercise',
      exerciseComplete: 'Exercise Complete!',
      yourAccuracy: 'Your Accuracy',
      feedback: 'Feedback',
      ruleReference: 'Rule Reference',
      tryAnotherExercise: 'Try Another Exercise',
      returnToDomains: 'Return to Domains',
    },
    // AI Helper
    aiHelper: {
      title: 'Sleep Medicine Assistant',
      placeholder: 'Ask me anything about sleep medicine...',
      send: 'Send',
      close: 'Close',
      greeting: "Hello! I'm your Sleep Medicine Assistant. How can I help you learn about sleep health today?",
      upgradeMessage: 'Continue this conversation with AI Pro ($15/mo) or Exam Prep Pro ($99/mo).',
    },
    // Organizations
    organizations: {
      title: 'For Organizations',
      subtitle: 'Enterprise-level sleep performance optimization',
      description: 'A science-based fatigue risk management program designed for organizations.',
      requestAssessment: 'Request Organizational Assessment',
      downloadOverview: 'Download Corporate Overview',
      benefits: 'Benefits for Your Organization',
      industries: 'Industries We Serve',
      contactForm: 'Contact Form',
    },
    // Errors & Empty States
    errors: {
      pageNotFound: 'Page Not Found',
      somethingWentWrong: 'Something went wrong',
      tryAgain: 'Please try again',
      goHome: 'Go to Homepage',
      unauthorized: 'Unauthorized access',
      forbidden: 'Access forbidden',
      networkError: 'Network error. Please check your connection.',
      sessionExpired: 'Session expired. Please sign in again.',
      invalidData: 'Invalid data provided',
    },
    // Toasts
    toasts: {
      saved: 'Changes saved successfully',
      deleted: 'Item deleted successfully',
      error: 'An error occurred',
      copied: 'Copied to clipboard',
      subscriptionUpdated: 'Subscription updated',
      progressSaved: 'Progress saved',
      certificateGenerated: 'Certificate generated',
      loginSuccess: 'Welcome back!',
      logoutSuccess: 'Logged out successfully',
      bookmarkAdded: 'Bookmark added',
      bookmarkRemoved: 'Bookmark removed',
    },
    // Exam Prep
    examPrep: {
      title: 'Exam Prep Pro',
      subtitle: 'Comprehensive certification preparation',
      description: 'Practice exams, question banks, and study materials for CPSGT and RPSGT certification.',
      questionBanks: 'Question Banks',
      practiceExams: 'Practice Exams',
      studyMaterials: 'Study Materials',
      startPractice: 'Start Practice',
      reviewAnswers: 'Review Answers',
      yourResults: 'Your Results',
      questionsAnswered: 'Questions Answered',
      correctAnswers: 'Correct Answers',
      timeSpent: 'Time Spent',
      averageScore: 'Average Score',
    },
    // Research
    research: {
      title: 'Research',
      subtitle: 'Sleep medicine research and publications',
      description: 'Explore the latest research in sleep medicine.',
    },
    // Personalization
    personalization: {
      recommendedForYou: 'Recommended for You',
      continueLearning: 'Continue Learning',
      continueWhereYouLeft: 'Continue where you left off',
      resumeReading: 'Resume Reading',
      popularTopics: 'Popular Topics',
      basedOnHistory: 'Based on your viewing history',
      recommendedForSleep: 'Recommended for Your Sleep',
      exploreMore: 'Explore More',
      noRecentActivity: 'Start exploring topics to get personalized recommendations',
      unlockAI: 'Unlock AI to ask questions about what you\'re learning',
      upgradeAudio: 'Upgrade to access full audio learning across all topics',
      continueConversation: 'Continue this conversation with full SHS-AI access',
      personalizedCoaching: 'Get personalized sleep coaching with behavioral guidance',
      unlockLearning: 'Unlock AI-powered learning for personalized guidance',
    },
    // Daily Engagement
    dailyEngagement: {
      dailyCheckin: 'Daily Check-In',
      completedForToday: 'Completed for today',
      yourStreak: 'Your Streak',
      days: 'days',
      day: 'day',
      todaysRecommendation: "Today's Recommendation",
      startToday: 'Start Today',
      readTopic: 'Read 1 Topic',
      listenAudio: 'Listen to Audio',
      askAI: 'Ask SHS-AI',
      logSleep: 'Log Sleep',
      unlockPersonalized: 'Unlock personalized guidance with SHS-AI',
      askDailyQuestion: 'Ask SHS-AI your daily question',
      getPersonalizedInsight: 'Get personalized sleep insight today',
      keepItUp: 'Keep it up!',
    },
    // Rewards System
    rewards: {
      sleepPoints: 'Sleep Points',
      yourProgress: 'Your Progress',
      achievements: 'Achievements',
      milestones: 'Milestones',
      pointsEarned: 'points earned',
      topicsCompleted: 'topics completed',
      badgesEarned: 'badges earned',
      currentStreak: 'Current Streak',
      totalPoints: 'Total Points',
      progressToNext: 'Progress to next achievement',
      newBadgeUnlocked: 'New badge unlocked!',
      keepLearning: 'Keep learning to unlock more',
      earnMoreWithAI: 'Earn more points with SHS-AI',
      unlockWithAI: 'Unlock with SHS-AI access',
      unlockWithCoach: 'Unlock with Sleep Coach access',
      lockedAchievement: 'Locked Achievement',
      resumeLearning: 'Resume Learning',
      haventCheckedIn: "You haven't checked in today",
      continueStreak: 'Continue your learning streak',
      buildingRoutine: "You're building a strong sleep routine",
      consistencyMatters: 'Consistency improves sleep outcomes',
    },
    // Certifications
    certifications: {
      title: 'Certifications',
      subtitle: 'Professional sleep education certification system',
      earned: 'Earned',
      inProgress: 'In Progress',
      available: 'Available',
      locked: 'Locked',
      certificate: 'Certificate',
      issuedOn: 'Issued',
      certificateId: 'Certificate ID',
      download: 'Download',
      share: 'Share',
      viewCertificate: 'View Certificate',
      noCertificates: 'No certificates yet',
      completeToEarn: 'Complete topics and learning tracks to earn certificates',
      exploreTopics: 'Explore Topics',
      noInProgress: 'No certifications in progress',
      startReading: 'Start reading topics to progress toward certifications',
      availableToStart: 'Available to Start',
      requireMembership: 'Require Membership',
      unlockWith: 'Unlock with',
      progress: 'Progress',
      continue: 'Continue',
      disclaimer: 'Sleep Health Services certificates acknowledge completion of educational training. They do not constitute clinical licenses or official professional certifications.',
      yourCertificate: 'Your Certificate',
      certifiesThat: 'This certifies that',
      hasCompleted: 'has successfully completed the training program',
      issuedForCompletion: 'Issued for completion of structured educational training',
      dateIssued: 'Date Issued',
    },
  },
  es: {
    // Common / Shared
    common: {
      signIn: 'Iniciar Sesión',
      signOut: 'Cerrar Sesión',
      signUp: 'Registrarse',
      account: 'Cuenta',
      myAccount: 'Mi Cuenta',
      myCertificates: 'Mis Certificados',
      followUs: 'Síguenos',
      language: 'Idioma',
      loading: 'Cargando...',
      error: 'Error',
      success: 'Éxito',
      save: 'Guardar',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      edit: 'Editar',
      close: 'Cerrar',
      submit: 'Enviar',
      back: 'Atrás',
      next: 'Siguiente',
      previous: 'Anterior',
      viewAll: 'Ver Todo',
      learnMore: 'Aprender Más',
      getStarted: 'Comenzar',
      tryFree: 'Probar Gratis',
      subscribe: 'Suscribirse',
      free: 'Gratis',
      premium: 'Premium',
      professional: 'Profesional',
      explorer: 'Explorador',
      search: 'Buscar',
      filter: 'Filtrar',
      all: 'Todos',
      select: 'Seleccionar',
      instead: 'en su lugar',
      noResults: 'No se encontraron resultados',
      tryAgain: 'Intentar de Nuevo',
      complete: 'Completo',
      perMonth: '/mes',
      comingSoon: 'Próximamente',
      availableNow: 'Disponible Ahora',
      required: 'Requerido',
      optional: 'Opcional',
      yes: 'Sí',
      no: 'No',
      confirm: 'Confirmar',
      continue: 'Continuar',
      start: 'Iniciar',
      finish: 'Terminar',
      complete: 'Completado',
      incomplete: 'Incompleto',
      inProgress: 'En Progreso',
      notStarted: 'No Iniciado',
      view: 'Ver',
      download: 'Descargar',
      share: 'Compartir',
      copy: 'Copiar',
      clear: 'Limpiar',
      reset: 'Reiniciar',
      refresh: 'Actualizar',
      tryAgain: 'Intentar de Nuevo',
      retake: 'Repetir',
      review: 'Revisar',
      bookmark: 'Marcar',
      bookmarked: 'Marcado',
      removeBookmark: 'Quitar Marcador',
      progress: 'Progreso',
      score: 'Puntuación',
      correct: 'Correcto',
      incorrect: 'Incorrecto',
      total: 'Total',
      of: 'de',
      minute: 'minuto',
      minutes: 'minutos',
      hour: 'hora',
      hours: 'horas',
      day: 'día',
      days: 'días',
      month: 'mes',
      perMonth: '/mes',
      year: 'año',
      perYear: '/año',
      quiz: 'Cuestionario',
      flashcards: 'Tarjetas de Estudio',
      learn: 'Aprender',
      practice: 'Practicar',
      exam: 'Examen',
      test: 'Prueba',
      question: 'Pregunta',
      answer: 'Respuesta',
      hint: 'Pista',
      explanation: 'Explicación',
      showAnswer: 'Mostrar Respuesta',
      hideAnswer: 'Ocultar Respuesta',
      flipCard: 'Voltear Tarjeta',
      nextCard: 'Siguiente Tarjeta',
      previousCard: 'Tarjeta Anterior',
      startQuiz: 'Iniciar Cuestionario',
      submitQuiz: 'Enviar Cuestionario',
      quizComplete: '¡Cuestionario Completado!',
      yourScore: 'Tu Puntuación',
      passed: 'Aprobado',
      failed: 'Reprobado',
      educationalOnly: 'Solo Educativo',
      disclaimer: 'Aviso Legal',
    },
    // Navigation
    nav: {
      home: 'Inicio',
      topics: 'Temas',
      academy: 'Academia Sleep Reset',
      videos: 'Videos',
      about: 'Acerca de',
      organizations: 'Para Organizaciones',
      membership: 'Membresía',
      techPocketGuide: 'Guía de Bolsillo',
      scoringMastery: 'Dominio de Scoring',
      examPrep: 'Preparación de Exámenes',
      questionBanks: 'Bancos de Preguntas',
      admin: 'Admin',
      adminPanel: 'Panel de Admin',
      adminLogin: 'Acceso Admin',
      testimonials: 'Testimonios',
      aboutDoctor: 'Sobre el Dr. Edgar',
      contact: 'Contacto / Trabajar conmigo',
      dashboard: 'Panel de Control',
      certificates: 'Certificados',
      research: 'Investigación',
      profile: 'Perfil',
      settings: 'Configuración',
      help: 'Ayuda',
      logout: 'Salir',
      sleepCoach: 'Coach de Sueño',
      cpapAdherence: 'Viaje CPAP',
      sleepAssessment: 'Evaluación del Sueño',
      wearableInsights: 'Perspectivas de wearables',
    },
    // Homepage
    home: {
      heroTitle: 'Avanzando la Educación en Medicina del Sueño y Entrenamiento Clínico',
      heroSubtitle: 'Aprendizaje interactivo, preparación para certificación y herramientas de aseguramiento de calidad en puntuación diseñadas para tecnólogos del sueño, clínicos y organizaciones de salud.',
      explorePathsBtn: 'Explorar Rutas de Aprendizaje',
      tryScoringBtn: 'Probar Scoring Mastery',
      whatWeOfferTitle: 'Una Plataforma Completa para el Aprendizaje de Medicina del Sueño',
      whatWeOfferDesc: 'Desde educación básica del sueño hasta entrenamiento avanzado en puntuación clínica, Sleep Health Services proporciona herramientas para estudiantes, tecnólogos y equipos de salud.',
      educationCard: 'Educación',
      educationDesc: 'Recursos interactivos que cubren trastornos del sueño, neurociencia y salud del sueño.',
      certPrepCard: 'Preparación para Certificación',
      certPrepDesc: 'Exámenes de práctica, casos de estudio y módulos de aprendizaje diseñados para certificación de tecnólogos del sueño.',
      clinicalCard: 'Entrenamiento Clínico',
      clinicalDesc: 'Ejercicios prácticos de puntuación con retroalimentación basada en reglas alineadas con las guías AASM.',
      qaCard: 'Aseguramiento de Calidad',
      qaDesc: 'Scoring Mastery ayuda a los laboratorios a estandarizar el entrenamiento y mejorar la precisión en la puntuación.',
      forWhoTitle: 'Diseñado para Cada Etapa del Aprendizaje en Medicina del Sueño',
      studentsCard: 'Estudiantes',
      studentsDesc: 'Construye una base sólida en ciencia del sueño y trastornos del sueño.',
      techsCard: 'Tecnólogos del Sueño',
      techsDesc: 'Practica puntuación, mejora la precisión y prepárate para exámenes de certificación.',
      healthcareCard: 'Profesionales de la Salud',
      healthcareDesc: 'Expande el conocimiento clínico y mantente actualizado con la medicina del sueño moderna.',
      labsCard: 'Laboratorios del Sueño',
      labsDesc: 'Entrena equipos y mantén consistencia en puntuación usando Scoring Mastery.',
      techGuideTitle: 'La Referencia Interactiva para Tecnólogos del Sueño',
      techGuideDesc: 'Accede a guías prácticas sobre conexión de pacientes, reglas de puntuación, artefactos, ritmos EKG, medicamentos y procedimientos clínicos.',
      openTechGuide: 'Abrir Guía de Bolsillo',
      scoringTitle: 'Entrena, Evalúa y Mejora la Precisión en Puntuación',
      scoringDesc: 'Scoring Mastery proporciona ejercicios interactivos de puntuación con retroalimentación estructurada basada en reglas de puntuación establecidas.',
      exploreScoringBtn: 'Explorar Scoring Mastery',
      choosePathTitle: 'Elige Tu Ruta de Aprendizaje',
      choosePathDesc: 'Desde educación básica hasta preparación para certificación profesional, encuentra la membresía adecuada para tus objetivos de aprendizaje.',
      learnPracticeImprove: 'Aprende. Practica. Mejora.',
      learnPracticeDesc: 'Sleep Health Services combina educación, entrenamiento interactivo y herramientas de práctica clínica para apoyar a la próxima generación de profesionales en medicina del sueño.',
      viewOptionsBtn: 'Ver Opciones de Aprendizaje',
      createAccountBtn: 'Crear Cuenta Gratis',
    },
    // Topics
    topics: {
      title: 'Temas de Medicina del Sueño',
      subtitle: 'Explora contenido educativo completo sobre salud del sueño y trastornos',
      browse: 'Explorar Temas de Medicina del Sueño',
      searchPlaceholder: 'Buscar temas, síntomas, tratamientos...',
      allTopics: 'Todos los Temas',
      noResults: 'No se encontraron temas que coincidan con su búsqueda.',
      video: 'Video',
      readMore: 'Leer Más',
      relatedTopics: 'Temas Relacionados',
      categories: 'Categorías',
      filterByCategory: 'Filtrar por Categoría',
      sortBy: 'Ordenar por',
      newest: 'Más Recientes',
      popular: 'Populares',
      alphabetical: 'Alfabético',
    },
    // Topic Detail
    topicDetail: {
      backToTopics: 'Volver a Temas',
      published: 'Publicado:',
      about: 'Acerca de',
      importantInfo: 'Información Importante',
      disclaimer: 'Este contenido educativo se proporciona solo con fines informativos. Siempre consulte con un profesional de la salud calificado.',
      relatedTopics: 'Temas Relacionados',
      learnMore: '¿Quieres Aprender Más Sobre',
      membershipDescription: 'Únete a nuestra comunidad para acceder a materiales educativos completos.',
      perMonth: 'por mes',
      perYear: 'por año',
      monthlyMembership: 'Membresía mensual',
      bestValue: 'MEJOR VALOR',
      joinMembership: 'Únete a la Membresía',
      whatYouGet: 'Lo que obtendrás:',
      benefit1: 'Guías completas de temas de medicina del sueño',
      benefit2: 'Videos educativos exclusivos',
      benefit3: 'Orientación y apoyo de expertos',
      benefit4: 'Recursos de capacitación para técnicos del sueño',
      benefit5: 'Preparación para el Examen CPSGT',
      benefit6: 'Preparación para el Examen RPSGT',
      // Audio & Learning
      unlockAudioMode: 'Desbloquear Modo de Audio',
      listenInEnglish: 'Listen in English',
      listenInSpanish: 'Escuchar en Español',
      keyTakeaways: 'Puntos Clave',
      unlockFullInteractive: 'Desbloquear Aprendizaje Interactivo Completo',
      unlockDescription: 'Obtén acceso a contenido completo, narración de audio y verificaciones interactivas de conocimiento con una membresía Explorer o superior.',
      unlockWithMembership: 'Desbloquear con Membresía',
      knowledgeCheck: 'Verificación de Conocimiento',
      askAI: 'Pregunta a SHS-AI',
      askAISubtitle: 'Obtén respuestas a tus preguntas sobre este tema',
    },
    // Hero (legacy)
    hero: {
      title: 'Educación en Medicina del Sueño',
      subtitle: 'Educador Clínico de Medicina del Sueño y Especialista en Salud Pública',
      description: 'Ayudo a pacientes, profesionales y tecnólogos del sueño a entender el sueño de forma clara y práctica.',
      exploreTopics: 'Explorar Temas',
      adminAccess: 'Acceso Administrativo',
      learnAcademy: 'Conocer Sleep Reset Academy',
      viewTraining: 'Ver Entrenamiento CPSGT y RPSGT',
    },
    // Stats
    stats: {
      educationalTopics: 'Temas Educativos',
      videoResources: 'Recursos en Video',
      categories: 'Categorías',
      students: 'Estudiantes',
      courses: 'Cursos',
      certificates: 'Certificados Emitidos',
    },
    // About
    about: {
      title: 'Educación Experta en Medicina del Sueño',
      description: 'Bienvenido al Centro Educativo de Sleep Health Services.',
      paragraph1: 'Bienvenido al Centro Educativo de Sleep Health Services.',
      paragraph2: 'Estamos comprometidos a brindar contenido educativo de alta calidad.',
      browseResources: 'Explorar Recursos Educativos',
    },
    // Membership
    membership: {
      title: 'Únete a Sleep Health Services',
      subtitle: 'Domina la ciencia. Construye la base.',
      description: 'Elige el nivel de membresía que se ajuste a tus objetivos de educación del sueño.',
      educationalValueLayer: 'Capa de Valor Educativo',
      choosePlan: 'Elige Tu Nivel de Acceso',
      currentPlan: 'Plan Actual',
      upgrade: 'Mejorar',
      downgrade: 'Reducir',
      cancel: 'Cancelar Suscripción',
      benefits: 'Beneficios',
      pricing: 'Precios',
      perMonth: '/mes',
      perYear: '/año',
      annually: 'anualmente',
      monthly: 'mensualmente',
      bestValue: 'Mejor Valor',
      mostPopular: 'Más Popular',
      examPrep: 'Preparación de Exámenes',
      popular: 'Popular',
      member: 'Miembro',
      youreA: 'Eres un',
      enjoyAccess: 'Disfruta tu acceso completo a todas las características de',
      featuresLabel: 'características',
      notIncluded: 'No incluido',
      includedInYourPlan: 'Incluido en Tu Plan',
      standaloneProduct: 'Producto Independiente',
      improveYourSleep: 'Mejora tu sueño por solo',
      goToSleepPlan: 'Ir a Tu Plan de Sueño',
      startCoaching: 'Iniciar Coaching de Sueño',
      lookingForTraining: '¿Buscas Entrenamiento para Técnicos?',
      exploreAcademy: 'Explorar Sleep Reset Academy',
      productEcosystem: 'Nuestro Ecosistema de Productos',
      strategicProducts: 'Productos estratégicos para cada etapa de tu viaje en medicina del sueño.',
      freeTier: {
        name: 'Gratis',
        description: 'Comienza tu viaje de educación del sueño',
        features: ['Navegar contenido del sitio web', 'Vista previa de resúmenes de temas'],
      },
      explorerTier: {
        name: 'Explorador',
        description: 'Acceso completo a más de 200 temas',
        tagline: 'Acceso completo a más de 200 temas',
        features: [
          'Acceso completo a TODOS los 200+ temas',
          'Contenido bilingüe (Inglés y Español)',
          'Audio (vista previa limitada)',
          'Asistente SHS-AI (acceso limitado)',
          'Sleep Coach (vista previa)',
        ],
      },
      deepSleepTier: {
        name: 'Acceso Completo',
        description: 'Temas ilimitados + audio + Sleep Coach + Wearables',
        tagline: 'Temas ilimitados + audio + Sleep Coach + Wearables',
        features: [
          'Todo lo de Explorador',
          'Acceso completo a temas premium',
          'Experiencia de aprendizaje con audio (ilimitado)',
          'Sleep Coach (acceso completo)',
          'Integración con dispositivos Wearables',
          'SHS-AI (acceso limitado)',
          'Contenido interactivo expandido',
        ],
      },
      masterMindTier: {
        name: 'Aprendizaje IA Pro',
        description: 'SHS-AI ilimitado + Sleep Coach + Wearables',
        tagline: 'SHS-AI ilimitado + Sleep Coach + Wearables',
        features: [
          'Todo lo de Acceso Completo',
          'Acceso ilimitado a SHS-AI',
          'Sleep Coach (acceso completo)',
          'Integración con dispositivos Wearables',
          'Contenido de aprendizaje avanzado',
          'Soporte de IA prioritario',
        ],
      },
      professionalTier: {
        name: 'Preparación Exámenes Pro',
        description: 'Entrenamiento avanzado + dominio de scoring',
        tagline: 'Entrenamiento avanzado + dominio de scoring',
        features: [
          'Acceso completo a la plataforma',
          'Bancos de preguntas + entrenamiento avanzado',
          'Uso ilimitado de SHS-AI',
          'Materiales de preparación y simulacros de examen',
        ],
        exclusions: [
          'Módulos de Sleep Reset Academy (comprados por separado)',
          'Funciones de gestión de equipos',
        ],
      },
      guarantee: 'Todos los planes incluyen garantía de devolución de 7 días. Cancela cuando quieras.',
      compareFeatures: 'Comparar Características',
      allFeatures: 'Todas las Características',
      feature: 'Característica',
      mo: 'mes',
      preview: 'Vista previa',
      full: 'Completo',
      unlimited: 'Ilimitado',
      features: {
        knowledgeHub: 'Artículos del Centro de Conocimiento del Sueño',
        premiumTopics: 'Temas Premium',
        audioLearning: 'Aprendizaje con Audio',
        aiAssistant: 'Asistente SHS-AI',
        examPrep: 'Materiales de Preparación para Exámenes',
        mockTests: 'Simulacros y Cuestionarios',
      },
      academyNote: 'es un producto separado diseñado para futuros tecnólogos del sueño. Los módulos de la Academia se compran individualmente.',
    },
    // Academy
    academy: {
      title: 'Sleep Reset Academy',
      subtitle: 'Domina la ciencia. Construye la base.',
      description: 'Educación profesional en medicina del sueño con preparación para certificación, cursos dirigidos por expertos y seguimiento de progreso.',
      heading: 'Sleep Reset Academy — Certificación Maestra CPSGT a RPSGT',
      intro: 'Sleep Reset Academy es la división educativa de Sleep Health Services (SHS), creada para entrenar a la próxima generación de tecnólogos del sueño.',
      viewOverview: 'Ver Resumen de la Academia',
      allCourses: 'Todos los Cursos',
      myCourses: 'Mis Cursos',
      inProgress: 'En Progreso',
      completed: 'Completado',
      startCourse: 'Iniciar Curso',
      continueCourse: 'Continuar',
      viewCourse: 'Ver Curso',
      lessons: 'Lecciones',
      modules: 'Módulos',
      duration: 'Duración',
      level: 'Nivel',
      beginner: 'Principiante',
      intermediate: 'Intermedio',
      advanced: 'Avanzado',
      certificate: 'Certificado',
      earnCertificate: 'Obtener Certificado',
      downloadCertificate: 'Descargar Certificado',
      progress: 'Progreso',
      completeLesson: 'Completar Lección',
      nextLesson: 'Siguiente Lección',
      previousLesson: 'Lección Anterior',
      courseCompleted: '¡Curso Completado!',
      congratulations: '¡Felicitaciones por completar este curso!',
      professionalCertification: 'Exam Prep Pro',
      publicEducation: 'Educación Pública',
      generalEducation: 'Educación General',
      knowledgeCheck: 'Verificación de Conocimiento',
      checkYourUnderstanding: 'Verifica Tu Comprensión',
      question: 'Pregunta',
      submitAnswers: 'Enviar Respuestas',
      tryAgain: 'Intentar de Nuevo',
      correct: '¡Correcto!',
      incorrect: 'Incorrecto',
      explanation: 'Explicación',
      score: 'Puntuación',
      passed: 'Aprobado',
      failed: 'Intentar de Nuevo',
      cpsgtTitle: 'Fundamentos del Técnico del Sueño CPSGT',
      cpsgtBody: 'Introducción completa para nuevos tecnólogos: bases del sueño, fundamentos de la polisomnografía, colocación de sensores, estadiaje, eventos respiratorios, fundamentos de PAP, seguridad y documentación.',
      cpsgtLine: 'Disponible en inglés y español.',
      cpsgtButton: 'Ver Curso CPSGT',
      rpsgtTitle: 'RPSGT Avanzado: Puntuación y Titulación',
      rpsgtBody: 'Entrenamiento avanzado en puntuación AASM, titulación PAP compleja, sueño pediátrico, parasomnias, trastornos de movimiento, artefactos y poblaciones especiales.',
      rpsgtLine: 'Disponible en inglés y español.',
      rpsgtButton: 'Ver Curso RPSGT',
      bundleTitle: 'Paquete Maestro Técnico del Sueño',
      bundleBody: 'Una ruta completa que combina Fundamentos CPSGT y Dominio RPSGT.',
      bundleLine: 'Incluye cuadernos de trabajo bilingües y exámenes de práctica.',
      bundleButton: 'Explorar el Paquete',
      howHeading: '¿Cómo funciona la academia?',
      howBody: 'Estudia con lecciones en video bilingües, presentaciones, cuadernos de trabajo y exámenes de práctica.',
      careerTrack: 'Producto de Carrera Profesional',
      whoIsThisFor: '¿Para quién es esto?',
      alreadyWorking: '¿Ya eres un tecnólogo en ejercicio? Mira',
      examPrepPro: 'Exam Prep Pro',
      coursesStarted: 'Cursos Iniciados',
      manageAcademy: 'Administrar Academia',
      modulesNotice: 'Los módulos de la Academia se compran individualmente — no están incluidos en ningún nivel de membresía.',
      errorLoading: 'Error al Cargar Cursos',
      noCoursesAvailable: 'No Hay Cursos Disponibles',
      coursesPreparing: '¡Los cursos están en preparación. Vuelve pronto!',
    },
    // Videos
    videos: {
      title: 'Biblioteca de Videos',
      subtitle: 'Educación experta en sueño a tu alcance',
      description: 'Explora nuestra colección completa de videos educativos sobre medicina del sueño.',
      searchPlaceholder: 'Buscar videos...',
      allVideos: 'Todos los Videos',
      featured: 'Destacados',
      recent: 'Recientes',
      popular: 'Populares',
      watchNow: 'Ver Ahora',
      duration: 'Duración',
      views: 'Vistas',
      category: 'Categoría',
      series: 'Serie',
      episode: 'Episodio',
      filterByTier: 'Filtrar por Nivel de Acceso',
      filterBySeries: 'Filtrar por Serie',
      freePreview: 'Vista Previa Gratis',
      premiumContent: 'Contenido Premium',
      unlockWith: 'Desbloquear con',
      upgradeToWatch: 'Mejora para Ver',
      startHere: 'Comienza Aquí',
      continueWatching: 'Continuar Viendo',
      recommended: 'Recomendado para Ti',
      relatedVideos: 'Videos Relacionados',
      noVideosFound: 'No se encontraron videos que coincidan con tus criterios.',
      tierRequired: 'Este contenido requiere membresía {tier} o superior.',
    },
    // Dashboard
    dashboard: {
      title: 'Mi Panel de Control',
      welcome: 'Bienvenido de nuevo',
      overview: 'Resumen',
      recentActivity: 'Actividad Reciente',
      courseProgress: 'Progreso del Curso',
      achievements: 'Logros',
      certificates: 'Mis Certificados',
      noCertificates: 'Aún no has obtenido certificados. ¡Completa un curso para obtener tu primer certificado!',
      downloadAll: 'Descargar Todos',
      continueLeaving: 'Continuar Donde Lo Dejaste',
      recommendedCourses: 'Cursos Recomendados',
      memberSince: 'Miembro desde',
      currentTier: 'Nivel Actual',
      upgradeAccount: 'Mejorar Cuenta',
      totalProgress: 'Progreso Total',
      exercisesCompleted: 'Ejercicios Completados',
      quizzesCompleted: 'Cuestionarios Completados',
      bookmarks: 'Marcadores',
      noActivity: 'Sin actividad reciente',
    },
    // Auth
    auth: {
      login: 'Iniciar Sesión',
      register: 'Crear Cuenta',
      email: 'Correo Electrónico',
      password: 'Contraseña',
      confirmPassword: 'Confirmar Contraseña',
      firstName: 'Nombre',
      lastName: 'Apellido',
      forgotPassword: '¿Olvidaste tu contraseña?',
      resetPassword: 'Restablecer Contraseña',
      rememberMe: 'Recordarme',
      noAccount: '¿No tienes una cuenta?',
      hasAccount: '¿Ya tienes una cuenta?',
      createOne: 'Crea una',
      signInHere: 'Inicia sesión aquí',
      orContinueWith: 'O continúa con',
      termsAgreement: 'Al crear una cuenta, aceptas nuestros Términos de Servicio y Política de Privacidad.',
      invalidCredentials: 'Correo o contraseña inválidos',
      loginFailed: 'No pudimos iniciar tu sesión. Por favor verifica tus datos e inténtalo de nuevo.',
      accountCreated: '¡Cuenta creada exitosamente!',
      welcomeBack: '¡Bienvenido de nuevo!',
      loggedInAs: 'Conectado como',
      accessDashboard: 'Accede a tu panel de educación del sueño',
      backToWebsite: 'Volver al sitio web',
      // Sprint 38 · P1 Fix — /education/register localization (Deep QA iter 153).
      createYourAccount: 'Crea tu cuenta',
      startJourney: 'Comienza hoy tu formación en salud del sueño',
      preferredLanguage: 'Idioma preferido',
      selectLanguage: 'Selecciona un idioma',
      passwordMinChars: 'Mínimo 6 caracteres',
      creatingAccount: 'Creando cuenta...',
      creatingAccountEllipsis: 'Creando tu cuenta...',
      accountCreatedRedirecting: '¡Cuenta creada exitosamente! Redirigiendo...',
      welcomeToSHS: '¡Cuenta creada! ¡Bienvenido a Sleep Health Services!',
      registrationFailed: 'Error al crear la cuenta',
      fillRequiredFields: 'Por favor completa todos los campos requeridos',
      passwordsDoNotMatch: 'Las contraseñas no coinciden',
      passwordTooShort: 'La contraseña debe tener al menos 8 caracteres',
      signIn: 'Inicia sesión',
      // Sprint 38 · Track A — Password Reset origination.
      forgotPasswordTitle: 'Restablece tu contraseña',
      forgotPasswordSubtitle: 'Ingresa el correo asociado a tu cuenta y te enviaremos un enlace para restablecerla.',
      forgotPasswordSubmit: 'Enviar enlace',
      forgotPasswordSending: 'Enviando...',
      forgotPasswordNeutral: 'Si existe una cuenta asociada con ese correo electrónico, se enviarán instrucciones para restablecer la contraseña.',
      forgotPasswordCheckInbox: 'Revisa tu bandeja de entrada. Si el correo no llega en unos minutos, revisa tu carpeta de spam o inténtalo de nuevo.',
      forgotPasswordBackToLogin: 'Volver a iniciar sesión',
      // Sprint 38 · Track C — Session expired notice.
      sessionExpired: 'Tu sesión expiró. Inicia sesión nuevamente.',
      // Password reset completion (existing flow, previously hardcoded strings)
      resetSetPasswordTitle: 'Establece tu contraseña',
      resetPasswordMinChars: 'Mínimo 8 caracteres',
      resetPasswordNewLabel: 'Nueva contraseña',
      resetPasswordConfirmLabel: 'Confirmar contraseña',
      resetPasswordSubmit: 'Establecer contraseña',
      resetPasswordSubmitting: 'Restableciendo...',
      resetPasswordSuccess: '¡Contraseña restablecida con éxito!',
      resetPasswordSuccessTitle: 'Contraseña restablecida',
      resetPasswordSuccessBody: 'Tu contraseña ha sido actualizada. Ahora puedes iniciar sesión con tu nueva contraseña.',
      resetPasswordGoToLogin: 'Ir a iniciar sesión',
      resetPasswordInvalidTitle: 'Enlace de restablecimiento inválido',
      resetPasswordInvalidBody: 'Este enlace de restablecimiento es inválido o ha expirado.',
      resetPasswordInvalidReturnBtn: 'Volver a iniciar sesión',
      resetPasswordVerifying: 'Verificando el enlace...',
      resetPasswordNoToken: 'No se proporcionó un token de restablecimiento',
      resetPasswordVerifyFailed: 'No se pudo verificar el enlace. Inténtalo de nuevo.',
      resetPasswordFailed: 'No se pudo restablecer la contraseña. Inténtalo de nuevo.',
      resetPasswordPasswordShort: 'La contraseña debe tener al menos 8 caracteres',
      resetPasswordSettingFor: 'Estableciendo contraseña para',
      resetPasswordEncrypted: 'Tu contraseña está cifrada de forma segura',
    },
    // Technologist
    technologist: {
      title: '¿Interesado en Convertirte en Técnico del Sueño?',
      description: 'Únete a nuestra comunidad para acceder a materiales de capacitación exclusivos.',
      examPrepTitle: 'Preparación de Exámenes Incluida',
      examPrepDescription: 'Prepárate para tu certificación con nuestros cursos de repaso completos:',
      cpsgt: 'Preparación CPSGT',
      rpsgt: 'Preparación RPSGT',
      joinMembership: 'Únete a Nuestra Comunidad',
      learnMore: 'Aprender Más',
      pricing: 'o',
      perMonth: '/mes',
      perYear: '/año',
      benefits: 'Acceso a cursos de capacitación, preparación CPSGT y RPSGT, y apoyo continuo',
    },
    // CTA
    cta: {
      title: '¿Necesitas Servicios Profesionales de Salud del Sueño?',
      description: 'Sleep Health Services ofrece soluciones completas de medicina del sueño.',
      contactUs: 'Contáctanos',
      readyToTransform: '¿Listo para Transformar Tu Educación del Sueño?',
      joinThousands: 'Únete a miles de estudiantes avanzando en su conocimiento de medicina del sueño.',
      viewMembership: 'Ver Planes de Membresía',
      createFreeAccount: 'Crear Cuenta Gratis',
    },
    // Footer
    footer: {
      tagline: 'Educación, Entrenamiento y Mejora de Calidad en Medicina del Sueño',
      description: 'Educación integral, preparación para certificación y herramientas de entrenamiento clínico para tecnólogos del sueño, clínicos y organizaciones de salud.',
      quickLinks: 'Enlaces Rápidos',
      browseTopics: 'Explorar Temas',
      becomeTechnologist: 'Convertirse en Técnico del Sueño',
      adminPortal: 'Portal Admin',
      contact: 'Contacto',
      location: 'Humacao, Puerto Rico',
      availableSoon: 'Disponible Pronto',
      copyright: 'Sleep Health Services. Todos los derechos reservados.',
      disclaimer: 'Contenido educativo solo con fines informativos. Consulte a profesionales de la salud para asesoramiento médico.',
      followUs: 'Síguenos',
      privacyPolicy: 'Política de Privacidad',
      termsOfService: 'Términos de Servicio',
    },
    // Tech Pocket Guide
    techPocketGuide: {
      title: 'Guía de Bolsillo',
      subtitle: 'La Referencia Interactiva para Tecnólogos del Sueño',
      description: 'Accede a guías prácticas sobre conexión de pacientes, reglas de puntuación, artefactos, ritmos EKG, medicamentos y procedimientos clínicos.',
      enterGuide: 'Entrar a la Guía',
      disclaimer: 'Este contenido es de referencia educativa — no para diagnóstico. Siempre siga los protocolos de su institución.',
      interactiveReference: 'Referencia Interactiva',
      modules: {
        ekg: 'Ritmos EKG',
        hookup: 'Conexión de Paciente',
        artifacts: 'Artefactos',
        scoring: 'Reglas de Puntuación',
        procedures: 'Procedimientos',
        medications: 'Medicamentos',
        glossary: 'Glosario',
      },
      // Module descriptions for landing page
      moduleDescriptions: {
        hookup: 'Sistema EEG 10-20, colocación de electrodos, guías de medición',
        artifacts: 'Vías de señal, artefactos comunes, lógica de corrección',
        scoring: 'Etapas del sueño, eventos respiratorios, despertares, PLMs, fórmulas',
        ekg: 'Reconocimiento educativo de ritmos, análisis de frecuencia/ritmo/P-QRS-T',
        procedures: 'Orden de operaciones, calibraciones, MSLT/MWT, plantillas',
        medications: 'Medicamentos para el sueño, mecanismos, contraindicaciones',
        glossary: 'Glosario buscable con definiciones vinculadas a reglas',
      },
      moduleInteractive: {
        hookup: ['Cuestionarios de colocación', 'Puntos de verificación visual'],
        artifacts: ['Tarjetas "¿Qué artefacto es este?"', 'Escenarios de corrección de señal'],
        scoring: ['Árboles de decisión de puntuación', 'Explicaciones ancladas en reglas'],
        ekg: ['Tarjetas de reconocimiento de ritmos', 'Indicaciones "¿Es preocupante?"'],
        procedures: ['Listas de verificación', 'Protocolos de muestra'],
        medications: ['Tarjetas de referencia educativa'],
        glossary: ['Búsqueda', 'Enlaces entre módulos'],
      },
      highPriority: 'ALTA PRIORIDAD',
      // Value propositions
      valueProps: {
        builtForLab: 'Diseñado para el Laboratorio',
        builtForLabPoints: [
          'Guía práctica paso a paso',
          'Solución de problemas del mundo real',
          'Explicaciones claras que los tecnólogos realmente entienden'
        ],
        interactive: 'Interactivo, No Estático',
        interactivePoints: [
          'Cuestionarios, tarjetas y escenarios',
          'Práctica de reconocimiento de ritmos',
          'Recorridos de decisiones de puntuación'
        ],
        safeEducational: 'Seguro y Educativo',
        safeEducationalPoints: [
          'Explicaciones ancladas en reglas',
          'Lenguaje no diagnóstico',
          'Diseñado para educación, no para prescribir'
        ],
      },
      // Audiences
      audiences: [
        'Tecnólogos del Sueño (estudiantes y profesionales)',
        'Supervisores de laboratorio y equipos de QA',
        'Educadores y programas de entrenamiento',
        'Médicos que buscan referencias estandarizadas',
        'Público general buscando educación precisa sobre el sueño'
      ],
      whoIsThisFor: '¿Para Quién Es Esto?',
      learnMode: 'Aprender',
      flashcardsMode: 'Tarjetas',
      quizMode: 'Cuestionario',
      allCategories: 'Todas las Categorías',
      cardOf: 'Tarjeta {current} de {total}',
      clickToFlip: 'Haz clic para voltear',
      characteristics: 'Características',
      causes: 'Causas',
      troubleshooting: 'Solución de Problemas',
      prevention: 'Prevención',
      clinical: 'Clínico',
      criteria: 'Criterios',
      tip: 'Consejo',
      urgent: 'Urgente',
      document: 'Documentar',
    },
    // Scoring Mastery
    scoringMastery: {
      title: 'Scoring Mastery™',
      heroTitle: 'Estandariza la Puntuación de Estudios del Sueño con Confianza',
      heroSubtitle: 'Scoring Mastery™ es una plataforma interactiva de entrenamiento y aseguramiento de calidad diseñada para mejorar la precisión de puntuación, reducir variabilidad y apoyar el rendimiento del laboratorio.',
      requestPilot: 'Solicitar Acceso Piloto',
      viewDemo: 'Ver Demostración',
      problemTitle: 'La Puntuación Inconsistente Es un Riesgo Oculto',
      problemDesc: 'Los laboratorios del sueño frecuentemente enfrentan variabilidad en la puntuación entre tecnólogos, llevando a inconsistencias, necesidades de reentrenamiento y posibles desafíos de auditoría.',
      problemPoint1: 'Variabilidad entre puntuadores',
      problemPoint2: 'Herramientas de entrenamiento estructurado limitadas',
      problemPoint3: 'Revisión QA manual que consume tiempo',
      problemPoint4: 'Dificultad para mantener consistencia entre equipos',
      solutionTitle: 'Un Enfoque Más Inteligente para Entrenamiento y Aseguramiento de Calidad',
      solutionDesc: 'Scoring Mastery™ combina entrenamiento interactivo con retroalimentación basada en reglas para ayudar a los tecnólogos a mejorar la precisión y mantener prácticas de puntuación consistentes.',
      capability1: 'Ejercicios interactivos de puntuación',
      capability2: 'Retroalimentación basada en reglas alineada con guías actuales',
      capability3: 'Seguimiento de rendimiento entre dominios',
      capability4: 'Entrenamiento estructurado para tecnólogos nuevos y experimentados',
      howItWorksTitle: 'Cómo Funciona Scoring Mastery',
      step1Title: 'Practicar',
      step1Desc: 'Los tecnólogos completan ejercicios estructurados de puntuación usando datos PSG simulados.',
      step2Title: 'Comparar',
      step2Desc: 'La plataforma compara la puntuación del usuario con un estándar de referencia.',
      step3Title: 'Aprender',
      step3Desc: 'La retroalimentación detallada explica el razonamiento detrás de cada decisión de puntuación.',
      step4Title: 'Mejorar',
      step4Desc: 'Los usuarios rastrean el progreso y mejoran el rendimiento con el tiempo.',
      featuresTitle: 'Construido para Entrenamiento Real en Laboratorios del Sueño',
      respiratory: 'Puntuación Respiratoria',
      respiratoryDesc: 'Practica identificación de apnea, hipopnea y RERA.',
      desaturation: 'Desaturación de Oxígeno',
      desaturationDesc: 'Aprende identificación de línea base y puntuación de desaturación.',
      plm: 'Movimientos Periódicos de Extremidades',
      plmDesc: 'Identifica secuencias de movimiento y calcula el índice PLM.',
      cardiac: 'Reconocimiento de Ritmo Cardíaco',
      cardiacDesc: 'Reconoce ritmos comunes y comprende protocolos de escalamiento.',
      pediatric: 'Modo Pediátrico',
      pediatricDesc: 'Ajusta criterios y entrenamiento para estudios del sueño pediátricos.',
      dashboard: 'Panel de Calidad',
      dashboardDesc: 'Rastrea rendimiento, identifica necesidades de entrenamiento y monitorea mejoras.',
      valueTitle: 'Diseñado para Laboratorios del Sueño',
      valueDesc: 'Scoring Mastery™ apoya tanto el aprendizaje individual como la mejora de calidad a nivel de equipo.',
      benefit1: 'Mejorar consistencia de puntuación',
      benefit2: 'Apoyar entrenamiento de tecnólogos',
      benefit3: 'Reducir carga de trabajo QA',
      benefit4: 'Prepararse para acreditación y auditorías',
      ctaTitle: 'Comienza con un Programa Piloto',
      ctaDesc: 'Ofrecemos acceso piloto para laboratorios del sueño interesados en evaluar Scoring Mastery™ con su equipo.',
      contactUs: 'Contáctanos',
      footerNote: 'Scoring Mastery™ está destinado solo para propósitos educativos y de entrenamiento y no reemplaza el juicio clínico o los protocolos de la institución.',
      organizationName: 'Nombre de la Organización',
      organizationType: 'Tipo de Organización',
      technicianCount: 'Número de Tecnólogos',
      contactName: 'Nombre de Contacto',
      contactEmail: 'Correo de Contacto',
      additionalInfo: 'Información Adicional',
      hospitalLab: 'Laboratorio del Sueño Hospitalario',
      idtf: 'IDTF / Laboratorio Independiente',
      healthSystem: 'Sistema de Salud (Multi-Sitio)',
      academic: 'Centro Médico Académico',
      vaCenter: 'Centro Médico VA',
      requestReceived: 'Solicitud Recibida',
      thankYou: 'Gracias por tu interés en Scoring Mastery™. Nuestro equipo revisará tu envío y te contactará pronto.',
      exercises: 'Ejercicios',
      domains: 'Dominios',
      selectDomain: 'Selecciona un Dominio',
      startExercise: 'Iniciar Ejercicio',
      exerciseComplete: '¡Ejercicio Completado!',
      yourAccuracy: 'Tu Precisión',
      feedback: 'Retroalimentación',
      ruleReference: 'Referencia de Regla',
      tryAnotherExercise: 'Probar Otro Ejercicio',
      returnToDomains: 'Volver a Dominios',
    },
    // AI Helper
    aiHelper: {
      title: 'Asistente de Medicina del Sueño',
      placeholder: 'Pregúntame cualquier cosa sobre medicina del sueño...',
      send: 'Enviar',
      close: 'Cerrar',
      greeting: '¡Hola! Soy tu Asistente de Medicina del Sueño. ¿Cómo puedo ayudarte a aprender sobre la salud del sueño hoy?',
      upgradeMessage: 'Continúa esta conversación con AI Pro ($15/mes) o Exam Prep Pro ($99/mes).',
    },
    // Organizations
    organizations: {
      title: 'Para Organizaciones',
      subtitle: 'Optimización del rendimiento del sueño a nivel empresarial',
      description: 'Un programa de gestión de riesgos de fatiga basado en ciencia diseñado para organizaciones.',
      requestAssessment: 'Solicitar Evaluación Organizacional',
      downloadOverview: 'Descargar Resumen Corporativo',
      benefits: 'Beneficios para Tu Organización',
      industries: 'Industrias que Servimos',
      contactForm: 'Formulario de Contacto',
    },
    // Errors & Empty States
    errors: {
      pageNotFound: 'Página No Encontrada',
      somethingWentWrong: 'Algo salió mal',
      tryAgain: 'Por favor intenta de nuevo',
      goHome: 'Ir al Inicio',
      unauthorized: 'Acceso no autorizado',
      forbidden: 'Acceso prohibido',
      networkError: 'Error de red. Por favor verifica tu conexión.',
      sessionExpired: 'Sesión expirada. Por favor inicia sesión de nuevo.',
      invalidData: 'Datos proporcionados inválidos',
    },
    // Toasts
    toasts: {
      saved: 'Cambios guardados exitosamente',
      deleted: 'Elemento eliminado exitosamente',
      error: 'Ocurrió un error',
      copied: 'Copiado al portapapeles',
      subscriptionUpdated: 'Suscripción actualizada',
      progressSaved: 'Progreso guardado',
      certificateGenerated: 'Certificado generado',
      loginSuccess: '¡Bienvenido de nuevo!',
      logoutSuccess: 'Sesión cerrada exitosamente',
      bookmarkAdded: 'Marcador añadido',
      bookmarkRemoved: 'Marcador eliminado',
    },
    // Exam Prep
    examPrep: {
      title: 'Exam Prep Pro',
      subtitle: 'Preparación integral para certificación',
      description: 'Exámenes de práctica, bancos de preguntas y materiales de estudio para certificación CPSGT y RPSGT.',
      questionBanks: 'Bancos de Preguntas',
      practiceExams: 'Exámenes de Práctica',
      studyMaterials: 'Materiales de Estudio',
      startPractice: 'Iniciar Práctica',
      reviewAnswers: 'Revisar Respuestas',
      yourResults: 'Tus Resultados',
      questionsAnswered: 'Preguntas Respondidas',
      correctAnswers: 'Respuestas Correctas',
      timeSpent: 'Tiempo Empleado',
      averageScore: 'Puntuación Promedio',
    },
    // Research
    research: {
      title: 'Investigación',
      subtitle: 'Investigación y publicaciones de medicina del sueño',
      description: 'Explora las últimas investigaciones en medicina del sueño.',
    },
    // Personalization
    personalization: {
      recommendedForYou: 'Recomendado para Ti',
      continueLearning: 'Continuar Aprendiendo',
      continueWhereYouLeft: 'Continúa donde lo dejaste',
      resumeReading: 'Continuar Leyendo',
      popularTopics: 'Temas Populares',
      basedOnHistory: 'Basado en tu historial de visualización',
      recommendedForSleep: 'Recomendado para Tu Sueño',
      exploreMore: 'Explorar Más',
      noRecentActivity: 'Comienza a explorar temas para obtener recomendaciones personalizadas',
      unlockAI: 'Desbloquea la IA para hacer preguntas sobre lo que estás aprendiendo',
      upgradeAudio: 'Actualiza para acceder al aprendizaje de audio completo en todos los temas',
      continueConversation: 'Continúa esta conversación con acceso completo a SHS-AI',
      personalizedCoaching: 'Obtén coaching personalizado del sueño con orientación conductual',
      unlockLearning: 'Desbloquea aprendizaje potenciado por IA para orientación personalizada',
    },
    // Daily Engagement
    dailyEngagement: {
      dailyCheckin: 'Check-In Diario',
      completedForToday: 'Completado por hoy',
      yourStreak: 'Tu Racha',
      days: 'días',
      day: 'día',
      todaysRecommendation: 'Recomendación de Hoy',
      startToday: 'Comenzar Hoy',
      readTopic: 'Leer 1 Tema',
      listenAudio: 'Escuchar Audio',
      askAI: 'Preguntar a SHS-AI',
      logSleep: 'Registrar Sueño',
      unlockPersonalized: 'Desbloquea orientación personalizada con SHS-AI',
      askDailyQuestion: 'Haz tu pregunta diaria a SHS-AI',
      getPersonalizedInsight: 'Obtén información personalizada del sueño hoy',
      keepItUp: '¡Sigue así!',
    },
    // Rewards System
    rewards: {
      sleepPoints: 'Puntos de Sueño',
      yourProgress: 'Tu Progreso',
      achievements: 'Logros',
      milestones: 'Hitos',
      pointsEarned: 'puntos ganados',
      topicsCompleted: 'temas completados',
      badgesEarned: 'insignias ganadas',
      currentStreak: 'Racha Actual',
      totalPoints: 'Puntos Totales',
      progressToNext: 'Progreso al siguiente logro',
      newBadgeUnlocked: '¡Nueva insignia desbloqueada!',
      keepLearning: 'Sigue aprendiendo para desbloquear más',
      earnMoreWithAI: 'Gana más puntos con SHS-AI',
      unlockWithAI: 'Desbloquea con acceso a SHS-AI',
      unlockWithCoach: 'Desbloquea con acceso al Coach del Sueño',
      lockedAchievement: 'Logro Bloqueado',
      resumeLearning: 'Continuar Aprendiendo',
      haventCheckedIn: 'No has registrado hoy',
      continueStreak: 'Continúa tu racha de aprendizaje',
      buildingRoutine: 'Estás construyendo una rutina de sueño sólida',
      consistencyMatters: 'La consistencia mejora los resultados del sueño',
    },
    // Certifications
    certifications: {
      title: 'Certificaciones',
      subtitle: 'Sistema profesional de certificación en educación del sueño',
      earned: 'Obtenidos',
      inProgress: 'En Progreso',
      available: 'Disponibles',
      locked: 'Bloqueados',
      certificate: 'Certificado',
      issuedOn: 'Otorgado el',
      certificateId: 'ID del Certificado',
      download: 'Descargar',
      share: 'Compartir',
      viewCertificate: 'Ver Certificado',
      noCertificates: 'Aún no tienes certificados',
      completeToEarn: 'Completa temas y pistas de aprendizaje para obtener certificados',
      exploreTopics: 'Explorar Temas',
      noInProgress: 'Sin certificaciones en progreso',
      startReading: 'Comienza a leer temas para progresar hacia certificaciones',
      availableToStart: 'Disponibles para Comenzar',
      requireMembership: 'Requieren Membresía',
      unlockWith: 'Desbloquear con',
      progress: 'Progreso',
      continue: 'Continuar',
      disclaimer: 'Los certificados de Sleep Health Services reconocen la finalización de formación educativa. No constituyen licencias clínicas ni certificaciones profesionales oficiales.',
      yourCertificate: 'Tu Certificado',
      certifiesThat: 'Certifica que',
      hasCompleted: 'ha completado satisfactoriamente el programa de formación',
      issuedForCompletion: 'Emitido por la finalización de formación educativa estructurada',
      dateIssued: 'Fecha de Emisión',
    },
  },
};

export const getTranslation = (language, key) => {
  const keys = key.split('.');
  let value = translations[language];

  // Fallback to English if language not found
  if (!value) {
    value = translations.en;
  }

  for (const k of keys) {
    value = value?.[k];
    if (value === undefined || value === null) {
      // Fallback to English
      let fallbackValue = translations.en;
      for (const fk of keys) {
        fallbackValue = fallbackValue?.[fk];
        if (fallbackValue === undefined || fallbackValue === null) {
          return key; // return the key itself if no translation found
        }
      }
      return fallbackValue;
    }
  }

  return value;
};
